module.exports = __webpack_public_path__ + "img/0Q3B7166_Foamcore.875846f6.jpg";